import type { Vehicle } from '#domain/Vehicle.ts';

export type VehicleWarningState = 'missing-license' | 'missing-pocket-driver-data-source';

export type VehicleWarningInput = Pick<Vehicle, 'hasOrderCommunicationLicense' | 'hasPocketDriverDataSource'>;

export const getVehicleWarningState = (vehicle: VehicleWarningInput | undefined): VehicleWarningState | undefined => {
    if (!vehicle) {
        return undefined;
    }

    if (vehicle.hasOrderCommunicationLicense === false) {
        return 'missing-license';
    }

    if (vehicle.hasOrderCommunicationLicense === true && vehicle.hasPocketDriverDataSource === false) {
        return 'missing-pocket-driver-data-source';
    }

    return undefined;
};

export const hasMissingPocketDriverDataSource = (vehicle: VehicleWarningInput | undefined) =>
    getVehicleWarningState(vehicle) === 'missing-pocket-driver-data-source';
